import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // Defer Meta Pixel loading to after page is interactive
    const loadPixel = () => {
      if (typeof window !== 'undefined' && !window.fbq) {
        ;(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
          if (f.fbq) return
          n = f.fbq = function () {
            n.callMethod
              ? n.callMethod.apply(n, arguments)
              : n.queue.push(arguments)
          }
          if (!f._fbq) f._fbq = n
          n.push = n
          n.loaded = true
          n.version = '2.0'
          n.queue = []
          t = b.createElement(e)
          t.async = true
          t.src = v
          s = b.getElementsByTagName(e)[0]
          if (s && s.parentNode) {
            s.parentNode.insertBefore(t, s)
          } else {
            b.head.appendChild(t)
          }
        })(
          window,
          document,
          'script',
          'https://connect.facebook.net/en_US/fbevents.js',
        )

        window.fbq('init', '1471171967744844')
        window.fbq('track', 'PageView')
      }
    }

    // Wait for page to be idle before loading pixel
    if ('requestIdleCallback' in window) {
      ;(window as any).requestIdleCallback(loadPixel, { timeout: 3000 })
    } else {
      setTimeout(loadPixel, 2000)
    }
  }, [])

  const trackAddToCart = (value?: number, currency: string = 'ARS') => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        value: value,
        currency: currency,
        content_name: 'Mega Pack de Arte',
        content_type: 'product',
      })
    }
  }

  return { trackAddToCart }
}
